import { create } from 'zustand';

const useExtractStore = create((set) => ({
  formDetail: [],
  setDataFormDetail: (data) =>
    set((state) => ({
      formDetail: data
    })),
  viewExtractName: '',
  viewExtractType: '',
  setViewDataExtraction: (data) =>
    set((state) => ({
      viewExtractName: data.name,
      viewExtractType: data.type
    })),

  hubname: '',
  setHubName: (name) =>
    set((state) => ({
      hubname: name
    })),

  openProject: false,
  setOpenProject: () =>
    set((state) => ({
      openProject: true
    })),
  setCloseProject: () =>
    set((state) => ({
      openProject: false
    }))
}));

export default useExtractStore;
